import { t } from "i18next"
import { Number, Text } from "components/common"
import { useMemo } from "react"
import { IconText } from "components/custom"
import { List } from "antd"
import cx from "clsx"
import styles from "../index.module.less"
const MediaSummary = ({ data, onLeadsClick }) => {
  const mediaData = useMemo(() => {
    return [
      ...(data?.billingTypeKey === "tripartite"
        ? [
            [
              t("Price Per Lead"),
              <Number value={data?.zameenMedia?.pricePerLead} isCurrency={true} digitAfterFraction={2} compact="" />,
            ],
            [
              t("Number of Leads"),
              <Number
                type="info"
                className="pointer bold text-underline"
                value={data?.zameenMedia?.numberOfLeads}
                onClick={onLeadsClick}
                compact=""
              />,
            ],
          ]
        : []),
      [
        t("Fee for IT Services"),
        <Number value={data?.zameenMedia?.totalServiceFee} isCurrency={true} digitAfterFraction={2} compact="" />,
      ],
      [
        t("Sales Tax"),
        <Number value={data?.zameenMedia?.taxAmount} isCurrency={true} digitAfterFraction={2} compact="" />,
      ],
      [t("Total"), <Number value={data?.zameenMedia?.total} isCurrency={true} digitAfterFraction={2} compact="" />],
    ]
  }, [data, onLeadsClick])

  return (
    <div className="pb-12" style={{ minHeight: 170 }}>
      <IconText
        title={t("Description of Services")}
        icon={"BsFileEarmarkText"}
        iconProps={{ style: { color: "#9D9D9D" }, hasBackground: true, size: "1em" }}
        gap={8}
        style={{ fontWeight: 600 }}
        className="mbe-12"
      />

      <List size="small" className={cx(styles.listingMain)}>
        {mediaData?.map(e => (
          <List.Item>
            <div className="gray-700">{e[0]}</div>
            <div>{e[1]}</div>
          </List.Item>
        ))}
      </List>
    </div>
  )
}
export default MediaSummary
